import axios from 'axios';

export default {
    state: {
        terminalsDic: null,
    },
    getters: {
        getTerminalsDic(state) {
            return state.terminalsDic
        },
    },
    mutations: {
        setTerminalsDic(state, data) {
            return state.terminalsDic = data
        },
    },
    actions: {
        terminalsDicRequest(context) {
            return axios.get('/api/dictionaries/terminals')
                .then(res => {
                    context.commit('setTerminalsDic', res.data)
                })
        },
    }
}